import React, { useContext } from 'react';
import { MobXProviderContext, observer } from 'mobx-react';
import Utils from '../lessonPlayer/services/UtilsService';
import HtmlComponent from '../lessonPlayer/components/HtmlComponent';
import { register } from '../i18n';

const t = register('PanelMenu');

const Rubric = observer(({ lessonElementId }) => {
  const {
    scoringManager
  } = useContext(MobXProviderContext);

  const rubric = scoringManager.rubricMap.get(lessonElementId);

  if (!rubric) {
    return null;
  }

  return (
    <div className='manuscript-rubric-wrapper'>
      <div className='manuscript-rubric-container'>
        <table className='manuscript-rubric font-content-container'>
          <thead>
            <tr>
              <th className='no-border font-content-container' />
              {rubric.columns.map((column) => {
                return (<th key={`rubric_header_${Utils.getKey()}`} className='columnHeader font-content-container'><HtmlComponent htmlStr={column} /></th>);
              })}
              <th className='no-border font-content-container'>{t('maxPoints')}</th>
            </tr>
          </thead>
          <tbody>
            {rubric.categories.map((category) => {
              return (
                <tr key={`rubric_row_${Utils.getKey()}`}>
                  <td className='category-label font-content-container'><HtmlComponent htmlStr={category.name} /></td>
                  {category.columns.map((column) => {
                    return (
                      <td key={`rubric_inner_col_${Utils.getKey()}`} className='rubric-cell font-content-container'>
                        <HtmlComponent htmlStr={column} />
                      </td>
                    );
                  })}
                  <td className='max-points font-content-container'>{category.maxPoints}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
});

export default Rubric;
